/**
 * Layout constants shared by PredictionsTable and PredictionsTableRow for the
 * phone rendering (viewport below 768px, see `useIsMobile`) of the predictions
 * tables. Desktop rendering does not use them.
 */

/**
 * Data columns wider than this are capped on phones so that more than one
 * column fits on the screen at a time. A column can override the cap through
 * `ColumnConfig.mobileWidth`.
 */
export const MOBILE_MAX_COLUMN_WIDTH = 220;

/** Width of the sticky row-number / actions column rendered on phones. */
export const MOBILE_ACTIONS_COLUMN_WIDTH = 56;
